import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Tag } from '@/modules/ui';

import type { Secret } from '../../../types';
import { container, intro, tag } from './CreatorTag.rules';

export const CreatorTag = ({ creator }: { creator: Secret['createdBy'] }) => {
    const { css } = useFela();

    if (!creator) return null;

    return (
        <div className={css(container)}>
            <Tag customStyle={tag}>
                <span className={css(intro)}>
                    <FormattedMessage id='secret.createdBy.label' />{' '}
                </span>
                {creator.name}
            </Tag>
        </div>
    );
};
